import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import React, { useState } from 'react';
import { Middleware, MiddlewareAdmin } from './Middleware';
import { TokenValidateExpiration } from './Token';
//import DataTable from 'react-data-table-component';
import DataTable from 'datatables.net-dt';
import { renderToString } from "react-dom/server";

window.AdminProviderDisabled = function(id)  {
    window.scrollTo(0, 0);
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("ChgB").style.display = "block";

    const token = localStorage.getItem("token");
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/disabled/'+id+'/'+token, {}, {
        headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Proveedor deshabilitado exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/administrador';
        }, 3000);
    });
}

window.AdminProviderEnabled = function(id) {
    window.scrollTo(0, 0);
    document.getElementById("messageError").style.display = "none";
    document.getElementById("messageError").innerHTML = "";
    document.getElementById("ChgB").style.display = "block";

    const token = localStorage.getItem("token");
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/provider/enabled/'+id+'/'+token, {}, {
        headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Proveedor habilitado exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/administrador';
        }, 3000);
    });
}

window.AdminProviderView = function(id, rfc) {
    window.location.href = '/administrador-proveedor-revision/'+id+'/'+rfc;
}

window.AdminProviderResendInvitation = function(id, email, rfc) {
    window.location.href = '/administrador-proveedor-reenviar-invitacion/'+id+'/'+email+'/'+rfc;
}

function Admin() {
    Middleware();
    MiddlewareAdmin();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    var decode = "";

    decode = jwtDecode(token);

    //Get documents
    const [providers, setProviders] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/admin/providers/get/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setProviders(response.data);
    });
    }, []);

    let table = new DataTable('#myTable', {
        destroy: true,
        data: providers,
        "columns": [
            { "data": "rfc" },
            { "data": "email" },
            { "data": "estatus", 
                render: function(data, type, row) {
                    if(row.estatus == 0) {
                        return '<label>Nuevo</label>';
                    }
                    if(row.estatus == 1) {
                        return '<label>Registrado</label>';
                    }
                    if(row.estatus == 2) {
                        return '<label>Pendiente modificar</label>';
                    }
                    if(row.estatus == 3) {
                        return '<label>En progreso modificar</label>';
                    }
                    if(row.estatus == 4) {
                        return '<label>En revisión</label>';
                    }
                    if(row.estatus == 5) {
                        return '<label>Registrado TIBCO</label>';
                    }
                    if(row.estatus == 6) {
                        return '<label>Error</label>';
                    }
                    if(row.estatus == 10) {
                        return '<label>En progreso registro</label>';
                    }
                    if(row.estatus == 100) {
                        return '<label>Inhabilitado</label>';
                    }
                }
            },
            { "data": "estatus", 
                render: function(data, type, row) {
                    if(row.estatus == 100) {
                        return `<input type="button" value="Habilitar" class="Button-Style" onClick={AdminProviderEnabled(${row.id})}>`;
                    } else {
                        return `<input type="button" value="Inhabilitar" class="Button-Style" onClick={AdminProviderDisabled(${row.id})}>`;
                    }
                }
            },
            { "data": "estatus", 
                render: function(data, type, row) {
                    if(row.estatus == 0 || row.estatus == 2) {
                        return `<input type="button" value="Reenviar" class="Button-Style" onClick={AdminProviderResendInvitation(`+row.id+`,"`+row.email+`","`+row.rfc+`")}>`;
                    } else {
                        return `<label></label>`
                    }
                }
            },
            { "data": "estatus", 
                render: function(data, type, row) {
                    if(row.estatus == 4) {
                        return `<input type="button" value="Revisar" class="Button-Style" onClick={AdminProviderView(`+row.id+`,"`+row.rfc+`")}>`;
                    } else {
                        return `<label></label>`
                    }
                }
            },
        ],
        
        retrieve: true,
        pagingType: "simple",
        ordering: false,
        info: false,
        language:
        {
            "processing": "Procesando...",
            "lengthMenu": "Mostrar _MENU_ registros",
            "zeroRecords": "No se encontraron resultados",
            "emptyTable": "Ningún dato disponible en esta tabla",
            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
            "search": "Buscar registro:",
            "infoThousands": ",",
            "loadingRecords": "Cargando...",
            "paginate": {
                "first": "Primero",
                "last": "Último",
                "next": "Siguiente",
                "previous": "Anterior"
            },
            "aria": {
                "sortAscending": ": Activar para ordenar la columna de manera ascendente",
                "sortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            "buttons": {
                "copy": "Copiar",
                "colvis": "Visibilidad",
                "collection": "Colección",
                "colvisRestore": "Restaurar visibilidad",
                "copyKeys": "Presione ctrl o u2318 + C para copiar los datos de la tabla al portapapeles del sistema. <br \/> <br \/> Para cancelar, haga clic en este mensaje o presione escape.",
                "copySuccess": {
                    "1": "Copiada 1 fila al portapapeles",
                    "_": "Copiadas %ds fila al portapapeles"
                },
                "copyTitle": "Copiar al portapapeles",
                "csv": "CSV",
                "excel": "Excel",
                "pageLength": {
                    "-1": "Mostrar todas las filas",
                    "_": "Mostrar %d filas"
                },
                "pdf": "PDF",
                "print": "Imprimir",
                "renameState": "Cambiar nombre",
                "updateState": "Actualizar",
                "createState": "Crear Estado",
                "removeAllStates": "Remover Estados",
                "removeState": "Remover",
                "savedStates": "Estados Guardados",
                "stateRestore": "Estado %d"
            },
            "autoFill": {
                "cancel": "Cancelar",
                "fill": "Rellene todas las celdas con <i>%d<\/i>",
                "fillHorizontal": "Rellenar celdas horizontalmente",
                "fillVertical": "Rellenar celdas verticalmentemente"
            },
            "decimal": ",",
            "searchBuilder": {
                "add": "Añadir condición",
                "button": {
                    "0": "Constructor de búsqueda",
                    "_": "Constructor de búsqueda (%d)"
                },
                "clearAll": "Borrar todo",
                "condition": "Condición",
                "conditions": {
                    "date": {
                        "after": "Despues",
                        "before": "Antes",
                        "between": "Entre",
                        "empty": "Vacío",
                        "equals": "Igual a",
                        "notBetween": "No entre",
                        "notEmpty": "No Vacio",
                        "not": "Diferente de"
                    },
                    "number": {
                        "between": "Entre",
                        "empty": "Vacio",
                        "equals": "Igual a",
                        "gt": "Mayor a",
                        "gte": "Mayor o igual a",
                        "lt": "Menor que",
                        "lte": "Menor o igual que",
                        "notBetween": "No entre",
                        "notEmpty": "No vacío",
                        "not": "Diferente de"
                    },
                    "string": {
                        "contains": "Contiene",
                        "empty": "Vacío",
                        "endsWith": "Termina en",
                        "equals": "Igual a",
                        "notEmpty": "No Vacio",
                        "startsWith": "Empieza con",
                        "not": "Diferente de",
                        "notContains": "No Contiene",
                        "notStartsWith": "No empieza con",
                        "notEndsWith": "No termina con"
                    },
                    "array": {
                        "not": "Diferente de",
                        "equals": "Igual",
                        "empty": "Vacío",
                        "contains": "Contiene",
                        "notEmpty": "No Vacío",
                        "without": "Sin"
                    }
                },
                "data": "Data",
                "deleteTitle": "Eliminar regla de filtrado",
                "leftTitle": "Criterios anulados",
                "logicAnd": "Y",
                "logicOr": "O",
                "rightTitle": "Criterios de sangría",
                "title": {
                    "0": "Constructor de búsqueda",
                    "_": "Constructor de búsqueda (%d)"
                },
                "value": "Valor"
            },
            "searchPanes": {
                "clearMessage": "Borrar todo",
                "collapse": {
                    "0": "Paneles de búsqueda",
                    "_": "Paneles de búsqueda (%d)"
                },
                "count": "{total}",
                "countFiltered": "{shown} ({total})",
                "emptyPanes": "Sin paneles de búsqueda",
                "loadMessage": "Cargando paneles de búsqueda",
                "title": "Filtros Activos - %d",
                "showMessage": "Mostrar Todo",
                "collapseMessage": "Colapsar Todo"
            },
            "select": {
                "cells": {
                    "1": "1 celda seleccionada",
                    "_": "%d celdas seleccionadas"
                },
                "columns": {
                    "1": "1 columna seleccionada",
                    "_": "%d columnas seleccionadas"
                },
                "rows": {
                    "1": "1 fila seleccionada",
                    "_": "%d filas seleccionadas"
                }
            },
            "thousands": ".",
            "datetime": {
                "previous": "Anterior",
                "next": "Proximo",
                "hours": "Horas",
                "minutes": "Minutos",
                "seconds": "Segundos",
                "unknown": "-",
                "amPm": [
                    "AM",
                    "PM"
                ],
                "months": {
                    "0": "Enero",
                    "1": "Febrero",
                    "10": "Noviembre",
                    "11": "Diciembre",
                    "2": "Marzo",
                    "3": "Abril",
                    "4": "Mayo",
                    "5": "Junio",
                    "6": "Julio",
                    "7": "Agosto",
                    "8": "Septiembre",
                    "9": "Octubre"
                },
                "weekdays": [
                    "Dom",
                    "Lun",
                    "Mar",
                    "Mie",
                    "Jue",
                    "Vie",
                    "Sab"
                ]
            },
            "editor": {
                "close": "Cerrar",
                "create": {
                    "button": "Nuevo",
                    "title": "Crear Nuevo Registro",
                    "submit": "Crear"
                },
                "edit": {
                    "button": "Editar",
                    "title": "Editar Registro",
                    "submit": "Actualizar"
                },
                "remove": {
                    "button": "Eliminar",
                    "title": "Eliminar Registro",
                    "submit": "Eliminar",
                    "confirm": {
                        "_": "¿Está seguro que desea eliminar %d filas?",
                        "1": "¿Está seguro que desea eliminar 1 fila?"
                    }
                },
                "error": {
                    "system": "Ha ocurrido un error en el sistema (<a target=\"\\\" rel=\"\\ nofollow\" href=\"\\\">Más información&lt;\\\/a&gt;).<\/a>"
                },
                "multi": {
                    "title": "Múltiples Valores",
                    "info": "Los elementos seleccionados contienen diferentes valores para este registro. Para editar y establecer todos los elementos de este registro con el mismo valor, hacer click o tap aquí, de lo contrario conservarán sus valores individuales.",
                    "restore": "Deshacer Cambios",
                    "noMulti": "Este registro puede ser editado individualmente, pero no como parte de un grupo."
                }
            },
            "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
            "stateRestore": {
                "creationModal": {
                    "button": "Crear",
                    "name": "Nombre:",
                    "order": "Clasificación",
                    "paging": "Paginación",
                    "search": "Busqueda",
                    "select": "Seleccionar",
                    "columns": {
                        "search": "Búsqueda de Columna",
                        "visible": "Visibilidad de Columna"
                    },
                    "title": "Crear Nuevo Estado",
                    "toggleLabel": "Incluir:"
                },
                "emptyError": "El nombre no puede estar vacio",
                "removeConfirm": "¿Seguro que quiere eliminar este %s?",
                "removeError": "Error al eliminar el registro",
                "removeJoiner": "y",
                "removeSubmit": "Eliminar",
                "renameButton": "Cambiar Nombre",
                "renameLabel": "Nuevo nombre para %s",
                "duplicateError": "Ya existe un Estado con este nombre.",
                "emptyStates": "No hay Estados guardados",
                "removeTitle": "Remover Estado",
                "renameTitle": "Cambiar Nombre Estado"
            }
        }
    }); 

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Proveedores</h1>
                        <br></br>
                        <br></br>
                        <div>
                            <p><i id="ChgB" className="fa fa-spinner fa-spin Chg"></i></p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <br></br>
                        <br></br>
                        <table className="table" id="myTable">
                            <thead>
                                <tr>
                                <th scope="col">RFC</th>
                                <th scope="col">Email</th>
                                <th scope="col">Estatus</th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                               
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Admin;
